import classNames from "classnames"
import filter from "lodash/filter"
import isEmpty from "lodash/isEmpty"

import portal from "portalConfig"
import Card from "components/shared/Card"
import { useTranslation } from "react-i18next"

import styles from "./ParkingSession.module.scss"

const ParkingInstructionsCard = () => {
  const { t } = useTranslation()
  const { features } = portal.config

  if (!features.hasParkingInstructions) {
    return null
  }

  const instructions = t("parkingSession.instructions", { returnObjects: true })
  const validInstructions = filter(
    instructions,
    (instruction) => !isEmpty(instruction.text) || !isEmpty(instruction.title)
  )

  return (
    <Card className={classNames(styles.card, styles.instructionsCard)}>
      <div className={styles.instructionsWrapper}>
        <div className={styles.instructionsHeadline}>Parking Instructions</div>
        <ol className={styles.instructionsList}>
          {validInstructions.map((instruction) => (
            <li
              key={instruction.position}
              className={styles.instructionsListItem}
            >
              <div className={styles.instructionsCopy}>
                {instruction.title && (
                  <div className={styles.instructionsTitle}>
                    {instruction.title}
                  </div>
                )}
                {instruction.text && (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: instruction.text.trimEnd()
                    }}
                  />
                )}
              </div>
            </li>
          ))}
        </ol>
      </div>
    </Card>
  )
}

export default ParkingInstructionsCard
